import React from 'react';
import Navbar from '../layouts/navbar';

const Resources = () => {
    return (
        <div>
            <Navbar head="Resources"></Navbar>

            <div className="container" style={{ marginTop: "60px" }}>
                <div className="row">
                    <div className="col-12 col-md-10">
                        <ul>
                            <li>Ambekar A, Agrawal A, Rao R, Mishra AK, Khandelwal SK, Chadda RK on behalf of the group of investigators for the National Survey on Extent and Pattern of Substance Use in India (2019). Magnitude of Substance Use in India. New Delhi: Ministry of Social Justice and Empowerment, Government of India</li>

                            <li>Price, M. (2008). Genes matter in addiction. Retrieved from https://www.apa.org/monitor/2008/06/genes-addict</li>

                            <li>Hammer, A. (2016). There's No Such Thing As An Addictive Personality. Retrieved from https://curiosity.com/topics/theres-no-such-thing-as-an-addictive-personality-curiosity/</li>
                            
                            <li>SciShow. (2016). Is There Such a Thing As An Addictive Personality?. Retrieved from https://www.youtube.com/watch?v=VbdCd2TyAo0</li>

                            <li>Association, A. (2013). Diagnostic and Statistical Manual of Mental Disorders, Fifth Edition (DSM-5®) (5th ed.). Washington, D.C.: American Psychiatric Publishing.</li>

                            <li>Glauser W. (2014). "High-functioning addicts": intervening before trouble hits. CMAJ : Canadian Medical Association journal = journal de l'Association medicale canadienne, 186(1), 19. doi:10.1503/cmaj.109-4667</li>

                            <li>Kelly, J. (2017). Working on addiction in the workplace - Harvard Health Blog. Retrieved from https://www.health.harvard.edu/blog/working-on-addiction-in-the-workplace-2017063011941</li>

                            <li>
                            NIDA. (2017, March 23). Health Consequences of Drug Misuse. Retrieved from https://www.drugabuse.gov/related-topics/health-consequences-drug-misuse on 2019, July 1
                            </li>

                            <li>
                            Sclar, K., & Editorial Staff. Signs of Drug Use | Drug Abuse Symptoms & Effects. Retrieved from https://drugabuse.com/symptoms-signs-drug-abuse-effects
                            </li>

                            <li>
                            Daley D. C. (2013). Family and social aspects of substance use disorders and treatment. Journal of food and drug analysis, 21(4), S73–S76. doi:10.1016/j.jfda.2013.09.038
                            </li>
                            <li>
                            Benton, S. (2009). Understanding the High-functioning Alcoholic: Professional Views and Personal Insights (The Praeger series on contemporary health and living). Praeger.
                            </li>
                            <li>
                            Elkins, C. (2018). Casual Drinking, Problem Drinking & Alcoholism. Retrieved from https://www.drugrehab.com/addiction/alcohol/casual-drinking-vs-alcoholism/
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>

    )
}

export default Resources;